module.exports = __webpack_public_path__ + "img/icons.354919c0.svg";